import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import TooltipArrow from '@/design-system/atoms/TooltipArrow.vue'
import { computed, ref, watch } from 'vue'

/*
Valid arrowPosition props:
----------------------------------------
bottom-left, bottom-center, bottom-right
top-left, top-center, top-right
center-left, center-right
----------------------------------------
*/

export default /*@__PURE__*/_defineComponent({
  __name: 'TooltipStandard',
  props: {
  arrowPosition: { type: String, default: 'top-center' },
  pointerEvent: { type: Object, default: () => {} },
  text: { type: String, default: '' },
  theme: { type: String, default: 'dark' }, // dark (default) or light
  positionAbsoulute: { type: Boolean, default: false }
},
  setup(__props) {

//  DISCLAIMER! The parent of the tooltip need to have position: relative

const props = __props
const pointerPosition = computed(() => {
  return props.pointerEvent
})
const tooltipRef = ref<HTMLElement | null>(null)
watch(pointerPosition, (newPos) => {
  const tooltip = tooltipRef.value
  if (!tooltip) return

  tooltip.style.left = newPos.x + 'px'
  tooltip.style.top = newPos.y + 'px'
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "tooltipRef",
    ref: tooltipRef,
    class: _normalizeClass(["tooltip", 
      'tooltip__' +
      __props.arrowPosition.split('-')[0] +
      ' tooltip__' +
      __props.arrowPosition +
      ' tooltip__theme-' +
      __props.theme
    ]),
    style: _normalizeStyle({ position: __props.positionAbsoulute ? 'absolute' : 'fixed' })
  }, [
    _createTextVNode(_toDisplayString(__props.text) + " ", 1),
    _createVNode(TooltipArrow, { class: "tooltip__arrow" })
  ], 6))
}
}

})